<template lang="pug">
	.sfc-onboarding-mobile-v3(@toggle-ob-modal="toggle()")
		section.close-section(@click="toggle()")
			svg.icon(xmlns='http://www.w3.org/2000/svg', width='20', height='20', viewBox='0 0 20 20')
				g(fill='#000000', fill-rule='evenodd')
					path(d='M1.986.722L19.9 18.076l-1.885 1.827L.1 2.549z')
					path(d='M.187 17.805L18.1.452l1.886 1.826L2.072 19.632z')

		h2.title
			| {{title}}
		.completion-progress.mb-5
			.progress(:style="`width: ${progressLength}%`")

		div(:key="enableModals")
			sfc-do-you-have-an-account(@next="next" v-show="currentComponent == 'sfc-do-you-have-an-account'")
			sfc-what-is-your-state-of-residence(@next="next" v-show="currentComponent == 'sfc-what-is-your-state-of-residence'")
			sfc-who-are-you-saving-for(@next="next" v-show="currentComponent == 'sfc-who-are-you-saving-for'")
			sfc-how-old-is-your-child(@next="next" v-show="currentComponent == 'sfc-how-old-is-your-child'" @title-update="titleUpdate")
			sfc-how-can-we-help-you-today(@next="next" v-show="currentComponent == 'sfc-how-can-we-help-you-today'")
			sfc-create-your-account(@next="next" v-show="currentComponent == 'sfc-create-your-account'")
			sfc-log-in-to-your-account(@next="next" v-show="currentComponent == 'sfc-log-in-to-your-account'")
			sfc-forgot-your-password(@next="next" v-show="currentComponent == 'sfc-forgot-your-password'")
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.sfc-onboarding-mobile-v3
	position fixed
	top 0
	left 0
	right 0
	height 100%
	overflow auto
	z-index 999
	display none
	background #fff
	padding 30px
	-webkit-overflow-scrolling touch
	>>> .link
		color #2486e7
	>>> .cursor-pointer
		cursor pointer
	>>> .close-in-word
		cursor pointer
		font-size: body-font-size
		top -25px
		right 0px
		position absolute
		color: #fff
	>>> .text-input
		.tb
			box-shadow: inset 0 1px 3px 0 rgba(101, 116, 134, 0.05);
			border solid 0.5px #657486
	>>> label
		font-size: body-font-size-md
	>>> h3
		margin-top 10px
		font-size: body-font-size-lg
		margin-bottom 30px
	>>> ul
		padding 0
		margin 0
		list-style none
		li
			margin-bottom 30px

.close-section
	display block
	margin-bottom 40px
	.icon
		height 15px
		width auto
		display inline-block
		vertical-align middle
</style>

<script>

import SfcWhoAreYouSavingFor from '@/common/components/savings-center/v3/onboarding/who-are-you-saving-for'
import SfcHowOldIsYourChild from '@/common/components/savings-center/v3/onboarding/how-old-is-your-child'
import SfcHowCanWeHelpYouToday from '@/common/components/savings-center/v3/onboarding/how-can-we-help-you-today'
import SfcCreateYourAccount from '@/common/components/savings-center/v3/onboarding/create-your-account'
import SfcLogInToYourAccount from '@/common/components/savings-center/v3/onboarding/log-in-to-your-account'
import SfcForgotYourPassword from '@/common/components/savings-center/v3/onboarding/forgot-your-password'
import SfcWhatIsYourStateOfResidence from '@/common/components/savings-center/v3/onboarding/what-is-your-state-of-residence'
import SfcDoYouHaveAnAccount from '@/common/components/savings-center/v3/onboarding/do-you-have-an-account'

export default {

	components: {
		SfcWhoAreYouSavingFor,
		SfcHowOldIsYourChild,
		SfcHowCanWeHelpYouToday,
		SfcCreateYourAccount,
		SfcLogInToYourAccount,
		SfcForgotYourPassword,
		SfcWhatIsYourStateOfResidence,
		SfcDoYouHaveAnAccount
	},

	props: {

	},

	data(){
		return {
			open: false,
			lastScroll: 0,
			progressLength: 25,
			title: "Who are you saving for?",
			currentComponent: "sfc-who-are-you-saving-for",
			lastComponent: false,
			enableModals: true
		}
	},

	mounted(){
		this.$root.$on('toggle-ob-modal', this.toggle)
	},

	computed: {

	},

	methods:{

		toggle(){
			this.open = !this.open

			if (this.open) {
				this.modalOpened()
				this.lastScroll = document.body.scrollTop

				document.querySelector('.sfc-onboarding-mobile-v3').classList.add("d-block");

				document.querySelector('html').classList.add("noscroll");
				document.body.classList.add("noscroll");
			}else{

				document.querySelector('.sfc-onboarding-mobile-v3').classList.remove("d-block");
				document.querySelector('html').classList.remove("noscroll");
				document.body.classList.remove("noscroll");

				document.body.scrollTop = this.lastScroll
				this.closeModal()
			}
		},

		async modalOpened(){

			if(this.savingsCenterFlow){
				this.progressLength = 0
				this.title = "Do you have a Savingforcollege.com account?",
				this.currentComponent = "sfc-do-you-have-an-account"
			}else{
				if(!this.$store.state.collegeSavingsUserOnboarding["state"]){
					this.progressLength = 0
					this.title = "What is your state of residence?",
					this.currentComponent = "sfc-what-is-your-state-of-residence"
				}
			}

			let token = this.$cookies.get("sfc_primary")

			let nextStep = undefined
			try{
				if (
					this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] &&
					this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] != "null" &&
					this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] != "undefined"
				){
					nextStep = this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
				}
			}
			catch(err){
				nextStep = undefined
			}

			if (token) {
				if (this.$store.state.collegeSavingsUserOnboarding  && nextStep){
					return this.$router.push({path: `/savings-center/${nextStep}`})
				}
			}else{
				this.$emit('shown', true)
				return
			}

			let collegeSavingsUser = undefined

			const query = `
				query{
					no_graphql_cache()
					college_savings_user_v3(sfc_token: "${token}"){
						id
						next_step_v3
						type_of_user
						children{
							id
							name
							age
						}
						state{
							id
							name
							slug
						}
						email
						primary_id
					}
				}
			`

			try {
				let result = await this.$httpService.graphql(query)
				collegeSavingsUser = result.data.college_savings_user_v3
			} catch (e) {
				collegeSavingsUser = undefined
			}

			if(collegeSavingsUser && collegeSavingsUser.next_step_v3){
				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: collegeSavingsUser.next_step_v3})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: collegeSavingsUser.type_of_user})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: collegeSavingsUser.children})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: collegeSavingsUser.state})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: collegeSavingsUser.email})

				return this.$router.push({path: "/savings-center/" + collegeSavingsUser.next_step_v3})
			}
		},

		closeModal(){
			this.progressLength = 25
			this.title = "Who are you saving for?",
			this.currentComponent = "sfc-who-are-you-saving-for"
			this.enableModals = false
			setTimeout(()=>{
				this.enableModals=true
				this.modalOpened()
			}, 300)
		},
		titleUpdate(title){
			this.title = title
		},
		next(progressLength, title, component, lastComponent = false, recoverHistory = false){

			if (lastComponent){
				this.lastComponent = lastComponent
			}
			if (recoverHistory && this.lastComponent){
				this.title = this.lastComponent.title
				this.currentComponent = this.lastComponent.component
				this.progressLength = this.lastComponent.progressLength
				this.lastComponent = false
			}
			else{
				if(this.progressLength + progressLength > 100){
					this.progressLength = 100
				} else if(this.progressLength + progressLength < 0){
					this.progressLength = 0
				}else{
					this.progressLength += progressLength
				}
				this.title = title
				this.currentComponent = component
			}
			document.getElementsByClassName('sfc-onboarding-mobile-v3')[0].scrollTop = 0
		}
	},
}
</script>

